import React, { useState, useMemo, useEffect } from 'react';
import {
  Button,
  Modal,
  Transfer,
  Table,
  Bubble,
  StatusTip,
} from 'tea-component';
import classnames from 'classnames';
// REMARK: rbd引用不要删除，后续 需要拖拽排序功能时，放开此处引用注释
// import * as rbd from './lib/react-beautiful-dnd.esm';
// import Loading from './components/Loading';
import KeywordsSelector from './components/KeywordsSelector';
import GameComp from './components/Game';
import { sortGames } from './utils';
import { IGamesTransferSelector } from './interfaces';
import { Game } from './type';
import { GameSegmentType } from '../../types';
import { BenchmarkSegment } from '../../_config/constant';
import { useIntl } from 'umi';
import Loading from '@/pages/intelligence/components/Loading';
import './index.scss';

// const { draggable, selectable } = Table.addons;
const { selectable, scrollable } = Table.addons;
const { LoadingTip } = StatusTip;

const GamesTransferSelector: React.FC<IGamesTransferSelector> = (props) => {
  const {
    entityType = 'mobile',
    gamePrimaryKey = 'id',
    title = 'Add Games to Compare',
    leftTitle = 'ADD',
    rightTitle = 'Selected',
    value,
    gameConfig,
    visible,
    setVisible,
    settingLoading = false,
    loadingAllGame = false,
    quickOptions,
    rigthTableAddons,
    onConfirm,
    onChange,
    onCancel,
  } = props;

  // 快捷筛选按钮不需要customize， 外部传入优先
  const shortcutList = quickOptions || BenchmarkSegment.filter(
    (item) => item.value !== 'customize',
  );

  const { formatMessage } = useIntl();

  const [isLoading, setIsLoading] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [similarGames, setSimilarGames] = useState<Game[]>([]);
  const [searchedGames, setSearchedGames] = useState<Game[]>([]);
  const [selectedGames, setSelectedGames] = useState<Game[]>([]);
  const [loading, setLoading] = useState(false);
  const [gameActive, setGameActive] = useState<{
    [key in GameSegmentType]?: boolean;
  }>({
    shooter: false,
    soc: false,
    mmo: false,
    rpg: false,
    casual: false,
  });

  const selectedGamesIds = useMemo(() => {
    if (!Array.isArray(selectedGames)) return [];
    return selectedGames
      .filter((item) => item)
      .map((item) => item[gamePrimaryKey]);
  }, [selectedGames]);

  // const isDisabled = useMemo(() => {
  //   return selectedGamesIds?.length >= (max || 6);
  // }, [selectedGamesIds?.length]);

  const similarGamesColumns = [
    {
      key: 'similarGamesHeader',
      header: '',
      render: (cvm: Game) => <GameComp {...cvm} />,
    },
  ];

  const handleCloseGame = (gameId: string) => {
    if (!gameId) return;
    const newSelectedGames = selectedGames.filter(
      (item) => item?.id !== gameId,
    );

    if (quickOptions) {
      // 关闭右侧某游戏，自动关联右侧header的选中状态
      const colseKeys: string[] = [];
      shortcutList.forEach((item: any) => {
        const game = gameConfig[item.value]?.find((item: any) => item?.id === gameId);
        if (game) {
          colseKeys.push(item.value);
        }
      });
      const active = { ...gameActive };
      colseKeys.forEach(key => {
        active[key] = false;
      });
      setGameActive(active);
    } else {
      if (gameConfig?.soc?.find((item) => item?.id === gameId)) {
        setGameActive({
          ...gameActive,
          soc: false,
        });
      }

      if (gameConfig?.shooter?.find((item) => item?.id === gameId)) {
        setGameActive({
          ...gameActive,
          shooter: false,
        });
      }

      if (gameConfig?.rpg?.find((item) => item?.id === gameId)) {
        setGameActive({
          ...gameActive,
          rpg: false,
        });
      }

      if (gameConfig?.mmo?.find((item) => item?.id === gameId)) {
        setGameActive({
          ...gameActive,
          mmo: false,
        });
      }

      if (gameConfig?.casual?.find((item) => item?.id === gameId)) {
        setGameActive({
          ...gameActive,
          casual: false,
        });
      }
    }
    setSelectedGames(newSelectedGames);
  };

  const searchedGamesColumns = [
    {
      key: 'searchedGamesHeader',
      header: '',
      render: (cvm: Game) => <GameComp {...cvm} keyword={keyword} />,
    },
  ];

  const selectedGamesColumns = [
    {
      key: 'selectedGamesHeader',
      header: '',
      render: (cvm: Game) => <GameComp {...cvm} showClose onClose={handleCloseGame} />,
    },
  ];

  const getRecordKey = (data: Game) => data ? data[gamePrimaryKey] : '';

  const handleKeywordChange = async (keyword: string) => {
    if (!entityType) return;
    if (!keyword) {
      setKeyword('');
      setSearchedGames([]);
      return;
    }
    setIsLoading(true);
    setKeyword(keyword);
    // const reg = new RegExp(keyword, 'ig');
    const filterList = similarGames.filter(
      (item) => item.entityName?.toLocaleLowerCase()?.includes(keyword?.toLocaleLowerCase()),
    );
    // const newKeywords = filterList.map((item) => ({
    //   value: item.id,
    //   text: getTextWithHighlight(item.entityName, keyword),
    // }));
    setSearchedGames(sortGames(filterList));
    setIsLoading(false);
  };

  const handleAddGames = (gamesIds: string[], e: any) => {
    if (!Array.isArray(gamesIds)) return;
    const remainingSelectedGames = selectedGames
      ?.filter((item) => gamesIds?.includes(item?.id))
      ?.map((item, index) => ({ ...item, sequence: index + 1 }));
    const remainingSelectedGamesIds = remainingSelectedGames?.map(
      (item) => item?.id,
    );
    const commingSelectedGames = gamesIds
      .filter((id) => !selectedGamesIds?.includes(id))
      .map((id) => (
        searchedGames?.find((item) => item.id === id) ||
          similarGames?.find((item) => item.id === id)
      ))
      .filter((item) => item)
      .map((item, index) => ({
        ...item,
        sequence: remainingSelectedGamesIds?.length + index + 1,
      }));
    const newSelectedGames = [
      ...remainingSelectedGames,
      ...commingSelectedGames,
    ];
    setSelectedGames(newSelectedGames);
    if (onChange instanceof Function) {
      onChange(newSelectedGames);
    }
  };

  const handleClearAll = () => {
    setGameActive({
      shooter: false,
      soc: false,
      mmo: false,
      rpg: false,
      casual: false,
    });
    setSelectedGames([]);
  };

  const handleSubmit = async () => {
    if (onConfirm instanceof Function) {
      onConfirm(selectedGames);
    }
  };

  const initData = async () => {
    if (Array.isArray(value)) {
      const newSelectedGames = value.map((item, index) => ({
        ...item,
        sequence: index + 1,
      }));
      setSelectedGames(newSelectedGames);
    }
  };

  useEffect(() => {
    const list =
      gameConfig?.all?.map((item, index) => ({
        id: item.id,
        entityType: item.entity_type,
        entityName: item.entity_name,
        releaseTime: item.release_time,
        cover: item.cover,
        publisher: item.company,
        matchScore: index,
      })) || [];
    setSimilarGames(list);

    const result: {
      [key in GameSegmentType]?: boolean;
    } = {};

    shortcutList?.forEach((item) => {
      const gameIdList = gameConfig?.[item.value as GameSegmentType]?.map(
        (config) => config?.id,
      );

      const customizeGameIdList = gameConfig?.customize?.map(
        (custom) => custom.id,
      );
      if (gameIdList?.every((game) => customizeGameIdList?.includes(game))) {
        result[item?.value as GameSegmentType] = true;
      } else {
        result[item?.value as GameSegmentType] = false;
      }
    });

    setGameActive(result);
  }, [gameConfig, visible]);

  const handleShortcutClick = async (type: GameSegmentType) => {
    if (settingLoading) return;
    const setAddGames = (gameType: GameSegmentType, flag: boolean) => {
      const socGameList = gameConfig?.[gameType]?.map((item) => item?.id) || [];
      const selectList = selectedGames.map((item) => item.id);
      const list = [...new Set([...socGameList, ...selectList])];

      if (flag) {
        const targetList = selectList.filter(
          (item) => !socGameList.includes(item),
        );
        handleAddGames(targetList, null);
      } else {
        handleAddGames(list, null);
      }
    };

    setAddGames(type, gameActive?.[type] as boolean);
    setGameActive({
      ...gameActive,
      [type]: !gameActive?.[type],
    });

    setKeyword('');
    setSearchedGames([]);
  };

  const resetData = () => {
    setKeyword('');
    setSearchedGames([]);
    setSimilarGames([]);
    setSelectedGames([]);
    setIsLoading(false);
  };

  const handleModalClose = () => {
    if (onCancel instanceof Function) {
      onCancel();
    }
    setVisible(false);
  };

  const renderSimilarGames = () => {
    if (!Array.isArray(similarGames) || !similarGames.length) return null;
    return (
      <>
        <div className="similar-games-header">{formatMessage({ id: 'dbi_similar_games' })}</div>
        <Table
          hideHeader
          disableHoverHighlight
          recordKey={getRecordKey}
          className="similar-games-table"
          columns={similarGamesColumns}
          records={similarGames}
          addons={[
            selectable({
              rowSelect: true,
              value: selectedGamesIds,
              onChange: (cvm, event) => {
                handleAddGames(cvm, event);
              }
            }),
            scrollable({
              virtualizedOptions: {
                height: 348,
                itemHeight: 65,
                onScrollBottom: () => { },
              },
            }),
          ]}
        />
      </>
    );
  };

  const renderSearchedGames = () => {
    if (!Array.isArray(searchedGames) || !searchedGames.length)
      return <div className="no-data-text">{formatMessage({ id: 'dbi_no_search_results' })}</div>;
    return loading ? (
      <LoadingTip />
    ) : (
      <Table
        className="dbi-benchmark-selector-result-table"
        hideHeader
        disableHoverHighlight
        recordKey={getRecordKey}
        columns={searchedGamesColumns}
        records={searchedGames}
        addons={[
          scrollable({
            virtualizedOptions: {
              height: 390,
              itemHeight: 64,
            },
            onScrollBottom: () => console.log('Bottom'),
          }),
          selectable({
            rowSelect: true,
            value: selectedGamesIds,
            onChange: (cvm, event) => {
              handleAddGames(cvm, event);
            },
          }),
        ]}
      />
    );
  };

  const renderLeftTransferCell = () => {
    if (isLoading || loadingAllGame) return <Loading />;

    if (keyword) return renderSearchedGames();

    if (Array.isArray(similarGames) && similarGames.length)
      return renderSimilarGames();

    return (
      <p className="no-data-text">
        <>
          {formatMessage({ id: 'dbi_compare_not_select_game_yet' })}
          <br />
          {formatMessage({ id: 'dbi_compare_please_search_game' })}
        </>
      </p>
    );
  };

  useEffect(() => {
    if (visible) {
      initData();
    } else {
      resetData();
    }
    // 数据加载完后，自动匹配搜索值
    if(keyword){
      handleKeywordChange(keyword);
    }
  }, [visible, loadingAllGame]);

  return (
    <>
      <Modal
        size="l"
        className="dbi-benchmark-customize-modal"
        caption={title}
        visible={visible}
        onClose={handleModalClose}
      >
        <Modal.Body>
          <Transfer
            className="dbi-benchmark-customize-transfer"
            leftCell={
              <Transfer.Cell
                className="benchmark-customize-transfer-l"
                title={formatMessage({ id: 'dbi_benchmark_add' })}
                scrollable={false}
                header={
                  <>
                    <KeywordsSelector
                      entityType={entityType}
                      similarGames={similarGames}
                      onChange={handleKeywordChange}
                    />
                  </>
                }
              >
                {renderLeftTransferCell()}
              </Transfer.Cell>
            }
            rightCell={
              <Transfer.Cell
                className="benchmark-customize-transfer-r"
                title={
                  <div className="benchmark-customize-transfer-titbox">
                    <span className="select-info">
                      {`${formatMessage({ id: 'dbi_compare_selected' })}(${selectedGames?.length})`}
                    </span>
                    {/* <span>
                      <span className="shortcut">Shortcut</span>

                    </span> */}
                    {selectedGames?.length > 0 && (
                      <Button
                        type="link"
                        className="btn-clear"
                        onClick={handleClearAll}
                      >
                        {formatMessage({ id: 'dbi_clear_all' })}
                      </Button>
                    )}
                  </div>
                }
                header={
                  <>
                    <div className="selected-header">
                      <div className="selected-header-tit">
                        <span>{formatMessage({ id: 'dbi_games' })}</span>
                      </div>

                      <div className="selected-header-shortcut">
                        {shortcutList.map((item) => (
                          <span
                            className={classnames([
                              'shortcut-tag',
                              {
                                active:
                                  gameActive?.[
                                    item?.value as GameSegmentType
                                  ] || false,
                              },
                              {
                                disabled: settingLoading,
                              },
                            ])}
                            onClick={() =>
                              handleShortcutClick(
                                item?.value as GameSegmentType,
                              )
                            }
                          >
                            {item?.isCustomName ? item?.text : formatMessage({ id: item?.text })}
                          </span>
                        ))}
                      </div>
                    </div>
                  </>
                }
              >
                {loading ? (
                  <div
                    style={{
                      height: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <LoadingTip />
                  </div>
                ) : selectedGames?.length > 0 ? (
                  <Table
                    hideHeader
                    disableHoverHighlight
                    className="selected-games-table"
                    columns={selectedGamesColumns}
                    records={selectedGames}
                    addons={
                      [
                        // REMARK: 此处拖拽插件配置不要删除，后续需要拖拽排序功能时，放开此处注释，以及rbd引用注释 即可
                        // draggable({
                        //   module: rbd,
                        //   onDragEnd: (records) => {
                        //     if (!Array.isArray(records)) return;
                        //     const newSelectedGames = records.map((item, index) => ({ ...item, sequence: index + 1 }));
                        //     setSelectedGames(newSelectedGames);
                        //   },
                        // }),
                        ...(rigthTableAddons || [])
                      ]
                    }
                  />
                ) : (
                  <p className="no-selected-message">
                    {formatMessage({ id: 'dbi_please_a_select_game' })}
                  </p>
                )}
              </Transfer.Cell>
            }
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="primary"
            disabled={!selectedGamesIds?.length}
            onClick={handleSubmit}
          >
            {formatMessage({ id: 'dbi_confirm' })}
          </Button>
          <Button type="weak" onClick={handleModalClose}>
            {formatMessage({ id: 'dbi_cancel' })}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default GamesTransferSelector;
